import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Default Navbar"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { class: "navbar navbar-expand-lg bg-body-tertiary" }, [
                _createElementVNode("div", { class: "container-fluid" }, [
                  _createElementVNode("a", {
                    class: "navbar-brand",
                    href: "#"
                  }, "Navbar"),
                  _createElementVNode("button", {
                    class: "navbar-toggler",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#navbarSupportedContent",
                    "aria-controls": "navbarSupportedContent",
                    "aria-expanded": "false",
                    "aria-label": "Toggle navigation"
                  }, [
                    _createElementVNode("span", { class: "navbar-toggler-icon" })
                  ]),
                  _createElementVNode("div", {
                    class: "collapse navbar-collapse",
                    id: "navbarSupportedContent"
                  }, [
                    _createElementVNode("ul", { class: "navbar-nav me-auto mb-2 mb-lg-0" }, [
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link active",
                          "aria-current": "page",
                          href: "#"
                        }, "Home")
                      ]),
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          href: "#"
                        }, "Link")
                      ]),
                      _createElementVNode("li", { class: "nav-item dropdown" }, [
                        _createElementVNode("a", {
                          class: "nav-link dropdown-toggle",
                          href: "#",
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, " Dropdown "),
                        _createElementVNode("ul", { class: "dropdown-menu" }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Action")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Another action")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("hr", { class: "dropdown-divider" })
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Something else here")
                          ])
                        ])
                      ]),
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link disabled",
                          "aria-disabled": "true"
                        }, "Disabled")
                      ])
                    ]),
                    _createElementVNode("form", {
                      class: "d-flex",
                      role: "search"
                    }, [
                      _createElementVNode("input", {
                        class: "form-control me-2",
                        type: "search",
                        placeholder: "Search",
                        "aria-label": "Search"
                      }),
                      _createElementVNode("button", {
                        class: "btn btn-outline-success",
                        type: "submit"
                      }, " Search ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<nav class=\"navbar navbar-expand-lg bg-body-tertiary\">\n<div class=\"container-fluid\">\n<a class=\"navbar-brand\" href=\"#\">Navbar</a>\n<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n<span class=\"navbar-toggler-icon\"></span>\n</button>\n<div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n<ul class=\"navbar-nav me-auto mb-2 mb-lg-0\">\n<li class=\"nav-item\">\n<a class=\"nav-link active\" aria-current=\"page\" href=\"#\">Home</a>\n</li>\n<li class=\"nav-item\">\n<a class=\"nav-link\" href=\"#\">Link</a>\n</li>\n<li class=\"nav-item dropdown\">\n<a class=\"nav-link dropdown-toggle\" href=\"#\" role=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDropdown\n</a>\n<ul class=\"dropdown-menu\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n</ul>\n</li>\n<li class=\"nav-item\">\n<a class=\"nav-link disabled\" aria-disabled=\"true\">Disabled</a>\n</li>\n</ul>\n<form class=\"d-flex\" role=\"search\">\n<input class=\"form-control me-2\" type=\"search\" placeholder=\"Search\" aria-label=\"Search\">\n<button class=\"btn btn-outline-success\" type=\"submit\">Search</button>\n</form>\n</div>\n</div>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Dark Navbar"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { class: "navbar navbar-expand-lg bg-dark" }, [
                _createElementVNode("div", { class: "container-fluid" }, [
                  _createElementVNode("a", {
                    class: "navbar-brand text-white",
                    href: "#"
                  }, "Navbar"),
                  _createElementVNode("button", {
                    class: "navbar-toggler",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#navbarSupportedContent",
                    "aria-controls": "navbarSupportedContent",
                    "aria-expanded": "false",
                    "aria-label": "Toggle navigation"
                  }, [
                    _createElementVNode("span", { class: "navbar-toggler-icon" })
                  ]),
                  _createElementVNode("div", {
                    class: "collapse navbar-collapse",
                    id: "navbarSupportedContent"
                  }, [
                    _createElementVNode("ul", { class: "navbar-nav me-auto mb-2 mb-lg-0" }, [
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white active",
                          "aria-current": "page",
                          href: "#"
                        }, "Home")
                      ]),
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white",
                          href: "#"
                        }, "Link")
                      ]),
                      _createElementVNode("li", { class: "nav-item dropdown" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white dropdown-toggle",
                          href: "#",
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, " Dropdown "),
                        _createElementVNode("ul", { class: "dropdown-menu" }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Action")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Another action")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("hr", { class: "dropdown-divider" })
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Something else here")
                          ])
                        ])
                      ]),
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white disabled",
                          "aria-disabled": "true"
                        }, "Disabled")
                      ])
                    ]),
                    _createElementVNode("form", {
                      class: "d-flex",
                      role: "search"
                    }, [
                      _createElementVNode("input", {
                        class: "form-control bg-dark me-2",
                        type: "search",
                        placeholder: "Search",
                        "aria-label": "Search"
                      }),
                      _createElementVNode("button", {
                        class: "btn btn-outline-success",
                        type: "submit"
                      }, " Search ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<nav class=\"navbar navbar-expand-lg bg-dark\">\n<div class=\"container-fluid\">\n<a class=\"navbar-brand text-white\" href=\"#\">Navbar</a>\n<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n<span class=\"navbar-toggler-icon\"></span>\n</button>\n<div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n<ul class=\"navbar-nav me-auto mb-2 mb-lg-0\">\n<li class=\"nav-item\">\n<a class=\"nav-link text-white active\" aria-current=\"page\" href=\"#\">Home</a>\n</li>\n<li class=\"nav-item\">\n<a class=\"nav-link text-white\" href=\"#\">Link</a>\n</li>\n<li class=\"nav-item dropdown\">\n<a class=\"nav-link text-white dropdown-toggle\" href=\"#\" role=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDropdown\n</a>\n<ul class=\"dropdown-menu\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n</ul>\n</li>\n<li class=\"nav-item\">\n<a class=\"nav-link text-white disabled\" aria-disabled=\"true\">Disabled</a>\n</li>\n</ul>\n<form class=\"d-flex\" role=\"search\">\n<input class=\"form-control bg-dark me-2\" type=\"search\" placeholder=\"Search\" aria-label=\"Search\">\n<button class=\"btn btn-outline-success\" type=\"submit\">Search</button>\n</form>\n</div>\n</div>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Primary Navbar"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { class: "navbar navbar-expand-lg bg-primary" }, [
                _createElementVNode("div", { class: "container-fluid" }, [
                  _createElementVNode("a", {
                    class: "navbar-brand text-white",
                    href: "#"
                  }, "Navbar"),
                  _createElementVNode("button", {
                    class: "navbar-toggler",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#navbarSupportedContent",
                    "aria-controls": "navbarSupportedContent",
                    "aria-expanded": "false",
                    "aria-label": "Toggle navigation"
                  }, [
                    _createElementVNode("span", { class: "navbar-toggler-icon" })
                  ]),
                  _createElementVNode("div", {
                    class: "collapse navbar-collapse",
                    id: "navbarSupportedContent"
                  }, [
                    _createElementVNode("ul", { class: "navbar-nav me-auto mb-2 mb-lg-0" }, [
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white active",
                          "aria-current": "page",
                          href: "#"
                        }, "Home")
                      ]),
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white",
                          href: "#"
                        }, "Link")
                      ]),
                      _createElementVNode("li", { class: "nav-item dropdown" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white dropdown-toggle",
                          href: "#",
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, " Dropdown "),
                        _createElementVNode("ul", { class: "dropdown-menu" }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Action")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Another action")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("hr", { class: "dropdown-divider" })
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#"
                            }, "Something else here")
                          ])
                        ])
                      ]),
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("a", {
                          class: "nav-link text-white disabled",
                          "aria-disabled": "true"
                        }, "Disabled")
                      ])
                    ]),
                    _createElementVNode("form", {
                      class: "d-flex",
                      role: "search"
                    }, [
                      _createElementVNode("input", {
                        class: "form-control me-2",
                        type: "search",
                        placeholder: "Search",
                        "aria-label": "Search"
                      }),
                      _createElementVNode("button", {
                        class: "btn btn-outline-success",
                        type: "submit"
                      }, " Search ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<nav class=\"navbar navbar-expand-lg bg-primary\">\n<div class=\"container-fluid\">\n<a class=\"navbar-brand text-white\" href=\"#\">Navbar</a>\n<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n<span class=\"navbar-toggler-icon\"></span>\n</button>\n<div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n<ul class=\"navbar-nav me-auto mb-2 mb-lg-0\">\n<li class=\"nav-item\">\n<a class=\"nav-link text-white active\" aria-current=\"page\" href=\"#\">Home</a>\n</li>\n<li class=\"nav-item\">\n<a class=\"nav-link text-white\" href=\"#\">Link</a>\n</li>\n<li class=\"nav-item dropdown\">\n<a class=\"nav-link text-white dropdown-toggle\" href=\"#\" role=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDropdown\n</a>\n<ul class=\"dropdown-menu\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n</ul>\n</li>\n<li class=\"nav-item\">\n<a class=\"nav-link text-white disabled\" aria-disabled=\"true\">Disabled</a>\n</li>\n</ul>\n<form class=\"d-flex\" role=\"search\">\n<input class=\"form-control me-2\" type=\"search\" placeholder=\"Search\" aria-label=\"Search\">\n<button class=\"btn btn-outline-success\" type=\"submit\">Search</button>\n</form>\n</div>\n</div>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}